import { INews } from '../Models/News';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const NewsService = {
    async getAllNews(id: number, area: string, page: number): Promise<INews[]> {
        const response = await fetch(
            '/Api/News/GetAllNews/?id=' +
                id +
                '&area=' +
                area +
                '&page=' +
                page,
            { headers }
        );
        return await response.json();
    },
};
